import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

// O tema global do app (src/theme.js) é mode: 'light' mas com
// background.paper escuro (#2B2E35) — Paper/Table/Tabs saem com texto de
// tema claro em cima de fundo escuro. As páginas existentes contornam com um
// ThemeProvider local (Datatable, FormDialog); as telas de RDNS fazem o mesmo.
const rdnsTheme = createTheme({
    typography: { fontFamily: ['sans-serif', 'Roboto', 'Montserrat'] },
    palette: {
        mode: 'light',
        primary: { main: '#e01b29' },
        warning: { main: '#ed6c02' },
        info: { main: '#0288d1' },
        success: { main: '#2e7d32' },
        error: { main: '#aa2525' },
        background: { paper: '#FFFFFF', default: grey[100] },
        text: { primary: '#2B2E35', secondary: '#5f6670' },
    },
});

export default rdnsTheme;
